import {getNavHeight} from './pinNav';

export default function () {
    $('body').scrollspy({
        target: '#model-nav',
        offset: getNavHeight()
    });
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/ModelNav/scrollSpyNav.js